import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { ChangelogPage } from '@/components/marketing/ChangelogPage';

export const Route = createFileRoute('/_public/changelog')({
  component: () => (
    <MarketingShell currentPath="/changelog">
      <ChangelogPage />
    </MarketingShell>
  ),
});
